import React from 'react'
import PropTypes from 'prop-types'
import { useRecoilValue } from 'recoil'
import Logo from './Logo'
import { siteData as siteDataState } from '../store/dataStore'
import { Triangle } from '../assets/svg/icons'

import { NotFoundSection, NotFoundContainer, NotFoundIcon } from '../styles/globalStyles'

const NotFound = () => {
  const siteData = useRecoilValue(siteDataState)
  return (
    <NotFoundSection>
      <Logo />
      <NotFoundContainer>
        <h3>
          404
          <span>Algo salió mal</span>
        </h3>
        <a href={siteData.url}>Visita nuestro Homepage</a>
        <NotFoundIcon>
          <Triangle />
        </NotFoundIcon>
      </NotFoundContainer>
    </NotFoundSection>
  )
}

NotFound.propTypes = {
  message: PropTypes.string.isRequired
}

export default NotFound
